import { Grid, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

interface SkeletonIndicatorProps {
    isLoading: boolean;
    count: number;
    variant: any;
}

export const SkeletonIndicator = ({ isLoading, count, variant }: SkeletonIndicatorProps) => {
    if (!isLoading) {
        return null;
    }
    return (
        <>
            {
                Array.from({ length: count }).map((_, index) => (
                    <Typography key={index} variant={variant} ><Skeleton /> </Typography>
                ))
            }
        </>
    );
};
